import type { API } from 'chessboard/api/config/types';

/**
 * Create the isAtEndOfLine method.
 */
export function createIsAtEndOfLine(context: API.Context) {
  /**
   * Determine whether or not we are at the end of the line.
   */
  return function isAtEndOfLine(): boolean {
    const { game } = context;

    const ids = game.ids();
    const line = context.api.getRawLines()[ids.line];

    return line.length - 1 === ids.move;
  };
}
